const ErrorImage = () => (
  <div className="image">
    <svg viewBox="0 0 60 40">
      <path fill="none" stroke="#333" d="M11 12 C 13 12, 16 11, 18 8" />
      <path fill="none" stroke="#333" d="M42 8 C 44 11, 47 12, 49 12" />
      <path fill="#333" d="M13 20 A 3 4 -5 1 0 19 20 A 3 4 -5 1 0 13 20" />
      <path fill="#333" d="M47 20 A 3 4 5 1 0 41 20 A 3 4 5 1 0 47 20" />
      <path fill="none" stroke="#333" d="M25 30 C 26 28, 33 26, 36 28" />
    </svg>

    <style jsx>{`
      .image {
        margin: 0 auto;
        max-width: 100px;
      }
    `}</style>
  </div>
);

export default ErrorImage;
